import React from 'react';
import {useFormContext} from "react-hook-form";
import Grid from "@mui/material/Grid";
import {RadioGroupQuestion} from "../../../../widgets/inputs/RadioGroupQuestion";
import {CustomAutoComplete} from "../../../../widgets/inputs/CustomAutoComplete";
import {comunita} from "../../../../../utils/dictionaries/ComunitaDict";
import {
	autocompleteRules, emailRegisterNone,
	phoneRegisterPrivate,
	valueRegister,
	valueRegisterNone
} from "../../../../../utils/RegisterUtils";
import CustomSelect from "../../../../widgets/inputs/CustomSelect";
import {tipiInfoLavoro, tipoForzeOrdine, tipoOpSanitario} from "../../../../../utils/arrays/Generics";
import {MenuItem} from "@mui/material";
import {listaScuole} from "../../../../../utils/arrays/Scuole";
import CustomDateInput from "../../../../widgets/inputs/CustomDateInput";
import CustomText from "../../../../widgets/inputs/CustomText";
import {MonitorStyle} from "../../../../../styles/pages/monitor/MonitorStyle";
import {PRESENTA_SINTOMI_3a} from "../../../../../strings/IT";

export const InfoLavorativeGrid = ({isCit = false}) => {
	const {errors, control, watch} = useFormContext();
	const monitorClasses = MonitorStyle();
	
	return (
		<React.Fragment>
			
			<Grid item xs={12}>
				<RadioGroupQuestion
					question={isCit ? "Sei ospite di una comunità?" : "É ospite di una comunità? (non ci lavora)"}
					control={control}
					autoFocus={false}
					defaultValue={""}
					rules={{required: true}}
					name={"appartieneComunita"}
					error={errors["appartieneComunita"]}
				/>
			</Grid>
			{
				watch("appartieneComunita") === "true" &&
				<Grid item xs={12}>
					<CustomAutoComplete
						freeSolo={true}
						label={isCit ? "Comunità a cui appartieni" : "Comunità a cui appartiene"}
						control={control}
						options={[...comunita, ""]}
						multiple={false}
						rules={autocompleteRules}
						name={"comunita"}
						error={errors["comunita"]}
					/>
				</Grid>
			}
			
			{
				!isCit && watch("appartieneComunita") !== "true" &&
				<Grid item xs={12}>
					<CustomSelect
						name={"tipoLavoro"}
						label={isCit ? "Che tipo di lavoro svolgi?" : "Che tipo di lavoro svolge? Fa parte di quale categoria?"}
						control={control}
						defaultValue={""}
						autoFocus={true}
						none={true}
						noneValue={""}
						rules={{required: true}}
						error={errors["tipoLavoro"]}
					>
						{tipiInfoLavoro.map((val, key) => {
							return (
								<MenuItem value={val} key={key}>
									{val}
								</MenuItem>
							);
						})}
					</CustomSelect>
				</Grid>
			}
			{/*//AMBITO SCOLASTICO*/}
			{
				(
					(watch("tipoLavoro") === tipiInfoLavoro[0]) ||
					(watch("tipoLavoro") === tipiInfoLavoro[1]) ||
					(watch("tipoLavoro") === tipiInfoLavoro[2])
				) &&
				<Grid item xs={12} className={monitorClasses.subQuestion}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<CustomAutoComplete
								label={"Nome istituto"}
								control={control}
								freeSolo={true}
								options={[...listaScuole, ""]}
								multiple={false}
								rules={autocompleteRules}
								name={"azienda"}
								error={errors["azienda"]}
							/>
						</Grid>
						<Grid item xs={12} sm={4}>
							<CustomDateInput
								label={"Ultima presenza?"}
								control={control}
								defaultValue={null}
								maxDate={new Date()}
								rules={{required: false}}
								name={"ultimoGiornoLavoro"}
								error={errors["ultimoGiornoLavoro"]}
							/>
						</Grid>
						<Grid item xs={12} sm={8}>
							<CustomText
								control={control}
								rules={valueRegisterNone}
								name={"dettaglioScuola"}
								label={"Classe e sezione"}
								autoFocus={false}
								error={errors["dettaglioScuola"]}
							/>
						</Grid>
					</Grid>
				</Grid>
			}
			{/*//SERVIZI PUBBLICI ESSENZIALI*/}
			{
				watch("tipoLavoro") === tipiInfoLavoro[3] &&
				<Grid item xs={12} className={monitorClasses.subQuestion}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<CustomSelect
								name={"professione"}
								label={"Che tipo di operatore sanitario?"}
								control={control}
								defaultValue={""}
								autoFocus={true}
								none={true}
								noneValue={""}
								rules={{required: false}}
								error={errors["professione"]}
							>
								{tipoOpSanitario.map((val, key) => {
									return (
										<MenuItem value={val} key={key}>
											{val}
										</MenuItem>
									);
								})}
							</CustomSelect>
						</Grid>
						<Grid item xs={12} sm={4}>
							<CustomDateInput
								label={"Ultima presenza?"}
								control={control}
								defaultValue={null}
								maxDate={new Date()}
								rules={{required: false}}
								name={"ultimoGiornoLavoro"}
								error={errors["ultimoGiornoLavoro"]}
							/>
						</Grid>
						<Grid item xs={12} sm={8}>
							<CustomText
								control={control}
								rules={{required: true}}
								error={errors["azienda"]}
								name={"azienda"}
								label={"Nome azienda"}
							/>
						</Grid>
						<Grid item xs={12}>
							<RadioGroupQuestion
								question={isCit ? "Sei seguito da medico competente?" : "É seguito da un medico competente?"}
								control={control}
								autoFocus={true}
								defaultValue={""}
								rules={{required: false}}
								name={"seguitoDaMedico"}
								error={errors["seguitoDaMedico"]}
							/>
						</Grid>
						{
							watch("seguitoDaMedico") === "true" &&
							<Grid item xs={12}>
								<CustomText
									control={control}
									rules={valueRegisterNone}
									name={"noteMedicoCompetente"}
									label={"Info medico competente"}
									autoFocus={false}
									error={errors["noteMedicoCompetente"]}
								/>
							</Grid>
						}
					</Grid>
				</Grid>
			}
			{
				watch("tipoLavoro") === tipiInfoLavoro[4] &&
				<Grid item xs={12} className={monitorClasses.subQuestion}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<CustomSelect
								name={"professione"}
								label={"Che tipo di forza armata?"}
								control={control}
								defaultValue={""}
								autoFocus={true}
								none={true}
								noneValue={""}
								rules={{required: false}}
								error={errors["professione"]}
							>
								{tipoForzeOrdine.map((val, key) => {
									return (
										<MenuItem value={val} key={key}>
											{val}
										</MenuItem>
									);
								})}
							</CustomSelect>
						</Grid>
						<Grid item xs={12} sm={4}>
							<CustomDateInput
								label={"Ultima presenza?"}
								control={control}
								defaultValue={null}
								maxDate={new Date()}
								rules={{required: false}}
								name={"ultimoGiornoLavoro"}
								error={errors["ultimoGiornoLavoro"]}
							/>
						</Grid>
						<Grid item xs={12} sm={8}>
							<CustomText
								control={control}
								rules={valueRegisterNone}
								name={"azienda"}
								label={"Luogo di lavoro / Azienda / Caserma"}
								autoFocus={false}
								error={errors["azienda"]}
							/>
						</Grid>
						<Grid item xs={12}>
							<CustomText
								control={control}
								rules={valueRegisterNone}
								name={"indirizzoAzienda"}
								label={"Indirizzo dell'azienda"}
								autoFocus={false}
								error={errors["indirizzoAzienda"]}
							/>
						</Grid>
						<Grid item xs={12}>
							<RadioGroupQuestion
								question={isCit ? "Sei seguito da un medico competente?" : "É seguito da un medico competente?"}
								control={control}
								autoFocus={true}
								defaultValue={""}
								rules={{required: false}}
								name={"seguitoDaMedico"}
								error={errors["seguitoDaMedico"]}
							/>
						</Grid>
						{
							watch("tipoLavoro") === tipiInfoLavoro[4] &&
							watch("seguitoDaMedico") === "true" &&
							<Grid item xs={12}>
								<CustomText
									control={control}
									rules={valueRegisterNone}
									name={"noteMedicoCompetente"}
									label={"Dati medico competente (nome, cognome, contatto)"}
									autoFocus={false}
									error={errors["noteMedicoCompetente"]}
								/>
							</Grid>
						}
					</Grid>
				</Grid>
			}
			{/*ALTRO - LAVORO GENERICO*/}
			{
				watch("tipoLavoro") === tipiInfoLavoro[7] &&
				<Grid item xs={12} className={monitorClasses.subQuestion}>
					<Grid container spacing={3}>
						<Grid item xs={12} sm={6}>
							<CustomText
								control={control}
								rules={valueRegister}
								name={"professione"}
								label={"Professione"}
								autoFocus={false}
								error={errors["professione"]}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<CustomText
								control={control}
								rules={valueRegisterNone}
								name={"azienda"}
								label={"Luogo di lavoro / Azienda"}
								autoFocus={false}
								error={errors["azienda"]}
							/>
						</Grid>
						<Grid item xs={12} sm={8}>
							<CustomText
								control={control}
								rules={valueRegisterNone}
								name={"indirizzoAzienda"}
								label={"Indirizzo dell'azienda"}
								autoFocus={false}
								error={errors["indirizzoAzienda"]}
							/>
						</Grid>
						<Grid item xs={12} sm={4}>
							<CustomDateInput
								label={"Ultima presenza?"}
								control={control}
								defaultValue={null}
								maxDate={new Date()}
								rules={{required: false}}
								name={"ultimoGiornoLavoro"}
								error={errors["ultimoGiornoLavoro"]}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<CustomText
								control={control}
								rules={valueRegisterNone}
								name={"rspp"}
								label={"RSPP / Datore di lavoro"}
								autoFocus={false}
								error={errors["rspp"]}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<CustomText
								control={control}
								rules={phoneRegisterPrivate}
								name={"cellulareRSPP"}
								label={"Cellulare RSPP"}
								autoFocus={false}
								error={errors["cellulareRSPP"]}
							/>
						</Grid>
						<Grid item xs={12}>
							<CustomText
								control={control}
								rules={emailRegisterNone}
								name={"emailRSPP"}
								label={"Email RSPP"}
								autoFocus={false}
								error={errors["emailRSPP"]}
							/>
						</Grid>
						<Grid item xs={12}>
							<RadioGroupQuestion
								question={isCit ? "Lavori in una comunità?" : "Lavora in una comunità?"}
								control={control}
								autoFocus={true}
								defaultValue={""}
								rules={{required: true}}
								name={"appartieneComunita"}
								error={errors["appartieneComunita"]}
							/>
						</Grid>
						{
							watch("appartieneComunita") === "true" &&
							<Grid item xs={12}>
								<CustomAutoComplete
									label={isCit ? "Comunità in cui lavori" : "Comunità a cui appartiene"}
									control={control}
									options={[...comunita, ""]}
									multiple={false}
									rules={autocompleteRules}
									name={"comunita"}
									error={errors["comunita"]}
								/>
							</Grid>
						}
					</Grid>
				</Grid>
			}
			
			{
				!isCit && watch("appartieneComunita") === "true" &&
				<Grid item xs={12}>
					<RadioGroupQuestion
						question={PRESENTA_SINTOMI_3a}
						control={control}
						autoFocus={true}
						defaultValue={""}
						rules={{required: true}}
						name={"presentaSintomi"}
						error={errors["presentaSintomi"]}
					/>
				</Grid>
			}
		
		</React.Fragment>
	);
}
